import { parsePhoneNumberFromString } from "libphonenumber-js/max"
import { z } from "zod"

export const TENANT_PHONE_MAX_LENGTH = 50
export const TENANT_PHONE_CHARACTERS = /^[+\d\s().-]+$/

export const TenantPhoneSchema = z.string().trim().max(TENANT_PHONE_MAX_LENGTH).nullable().optional()
  .transform((value, context) => {
    if (!value) return null
    const phone = parsePhoneNumberFromString(value, { extract: false })
    if (!value.startsWith("+") || !TENANT_PHONE_CHARACTERS.test(value) || !phone?.isValid()) {
      context.addIssue({ code: z.ZodIssueCode.custom, message: "Enter a valid phone number including its country code." })
      return z.NEVER
    }
    return phone.number
  })
